// extracted by mini-css-extract-plugin
export default {"award":"award_award__jeBlJ","img":"award_img__ETgCR","date":"award_date__OzwSN","name":"award_name__986rF","city":"award_city__Bbyvt"};